import React from "react";
import moment from "moment";
import { Box } from "@mui/material";

import { DATE_FORMAT } from "../../../../constants";
import { MainInfoValue } from "../../../../components/ui";
import { IntlFormatUSD } from "../../../../utils";
import { useCustomerProvider } from "../../../../context";

const Evaluations = (): React.ReactElement => {
  const { customerEvaluation } = useCustomerProvider();
  const timeStamp = moment(customerEvaluation.timestamp);

  return (
    <div>
      <MainInfoValue title="PnL">{IntlFormatUSD(customerEvaluation.pnl || 0)}</MainInfoValue>
      <MainInfoValue title="Consistency">
        <Box display="flex" flexDirection="column-reverse">
          <span>{IntlFormatUSD(customerEvaluation.largest_pnl)}</span>
          <span>{customerEvaluation.largest_pnl_percent}%</span>
        </Box>
      </MainInfoValue>
      <MainInfoValue title="Days Traded">{customerEvaluation.days_traded}</MainInfoValue>
      <MainInfoValue title="Timestamp">
        {timeStamp.isValid() ? timeStamp.format(DATE_FORMAT) : ""}
      </MainInfoValue>
    </div>
  );
};

export default Evaluations;
